import { api } from "./api";

const KEY = "kolt.tool_source";
export const TOOL_NAMES = {
  "dpi-checker": "Image DPI Checker", "bleed-calculator": "Bleed & Safe-Zone", "pantone-converter": "Pantone Converter",
  "prepress-checklist": "Prepress Checklist", "label-size-finder": "Label Size Finder", "banner-calculator": "Banner Calculator",
  "booklet-planner": "Booklet Planner", "foil-color-chart": "Foil Color Chart", "spine-calculator": "Spine Calculator", "template-library": "Template Library",
  "shipping-estimator": "Delivery Estimator", "print-glossary": "Print Glossary", "colorplan-swatches": "Colorplan Swatches", "paper-weight-converter": "Paper Weight Converter",
  "envelope-finder": "Envelope Finder", "suite-postage": "Suite & Postage", "wedding-timeline": "Wedding Timeline", "foil-guide": "Foil/Letterpress Guide",
  "imposition-calculator": "Imposition", "rich-black-checker": "Rich Black", "folding-calculator": "Folding", "print-method-compare": "Print Method Compare",
  "label-roll-spec": "Label Roll Spec", "signage-distance": "Signage Distance", "material-selector": "Material Selector", "paper-feel": "Paper Feel",
};

export function trackTool(tool, action, meta = {}) {
  if (!tool) return;
  if (action === "view") {
    const k = `kolt.tool_view.${tool}`;
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
  }
  api.post("/tools/events", { tool, action, meta, path: window.location.pathname }).catch(() => {});
}

export const rememberToolSource = (tool) => { if (tool) sessionStorage.setItem(KEY, tool); };
export const toolSource = () => sessionStorage.getItem(KEY) || null;
export const withTool = (to, tool) => (tool && typeof to === "string" && !to.startsWith("#") ? `${to}${to.includes("?") ? "&" : "?"}tool=${encodeURIComponent(tool)}` : to);
